<template>
  <v-row justify="center">
    <v-dialog
        v-model="editInstitution"
        max-width="70%"
        persistent
    >
      <v-card>
        <v-card-title>
          <div class="row p-3">
            <icon class="pt-1 mr-3" name="institution" width="w-5" height="h-5" color="#000"></icon><span class="text-h6">Edit Institution</span>
          </div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="12" sm="12">
                <v-col cols="12" md="12" sm="12">
                  <v-row class="ml-1">
                    <v-avatar size="50">
                      <v-img :src="`${mediaUrl+institutionLogo}`"></v-img>
                    </v-avatar>
                    <v-file-input
                        outlined
                        label="Institution Logo"
                        v-model="institutionLogo"
                        @change="onChange"
                        accept="image/*"
                    ></v-file-input>

                  </v-row>
                  <v-text-field
                      outlined
                      v-model="institutionShortform"
                      :counter="10"
                      :rules="nameRules"
                      label="Institution Short Form *"
                      prepend-icon="mdi-text-short"
                      required >
                  </v-text-field>

                  <v-text-field
                      outlined
                      v-model="institutionDescriptions"
                      :counter="150"
                      label="Institution Name *"
                      prepend-icon="mdi-text-long"
                      required
                  >
                  </v-text-field>

                </v-col>
              </v-col>
            </v-row>

            <div class="flex justify-end text-white">
              <v-btn
                  color="red"
                  class="text-capitalize mr-2"
                  right
                  small
                  @click="closeDialog"
              >
                <icon name="close" width="w-5" height="h-5" color="#ffffff" ></icon>
                <span class="text-white">Cancel</span>
              </v-btn>
              <v-btn color="primary"
                     class="text-capitalize"
                     right
                     small
                     @click="editInstitutions"
              >
                <icon name="save" width="w-5" height="h-5" color="#ffffff" ></icon>
                Save
              </v-btn>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Icon from "@/views/Icon.vue";


export default {
  name: "EditInstitution",
  components: {Icon},
  data: ()=> ({
    dialog: false,
    nameRules: [
      v => !!v || 'Name is required',
      v => (v && v.length <= 10) || 'Name must be less than 10 characters',
    ]

  }),
  props: [
      'institutionUniqueId',
      'institutionShortform',
      'institutionDescriptions',
      'institutionLogo',
      'institutionAdminUsername',
      'categoryUniqueId',

      'editInstitution',
  ],

  computed: {

    getInstitutionCategoryList (){
      return this.$store.getters.getInstitutionCategoryList
    },

    mediaUrl() {
      let _mediaUrl = process.env.VUE_APP_MEDIA_SERVER;
      return `${_mediaUrl}`;
    }
  },

  methods: {
    async closeDialog() {
      this.institutionShortform = ""
      this.institutionDescriptions = ""

      this.institutionAdminUsername = ""
      this.institutionLogo = this.$store.getters.getLogoFullName
      this.institutionLogo = ""

      await this.$emit('close-dialog')

    },

    async editInstitutions() {
      let input = {
        institutionUniqueId: this.institutionUniqueId,
        institutionShortform: this.institutionShortform,
        institutionDescriptions: this.institutionDescriptions,
        institutionAdminUsername: this.institutionAdminUsername,
        // institutionLogo: this.$store.getters.getLogoFullName,
        institutionLogo: this.institutionLogo,
        categoryUniqueId: this.categoryUniqueId

      }
      await this.$store.dispatch('editInstitution', input)
      this.institutionShortform = ""
      this.institutionDescriptions = ""
      this.institutionAdminUsername = ""
      this.institutionLogo = ""

      this.$emit('close-dialog')
    },

    async onChange() {
      let file = this.institutionLogo;

      const sendData = {
        'file': file,
        'type': file.type,
        'data': file.size,
      };

      await this.$store.dispatch('uploadInstitutionLogo', sendData);
    },
  },
}
</script>

<style scoped>

</style>